// import React from 'react';
// import smsphoto2 from '../../../src/Components/assets/smsphoto2.png'
// import { RiCustomerService2Fill } from "react-icons/ri";


// // ... (icons and features definitions remain unchanged)
// const icons = {

//   Rupee: (props) => (
//     <svg
//       {...props}
//       xmlns="http://www.w3.org/2000/svg"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       // UPDATED CLASSES BELOW:
//       className="w-8 h-8 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2"
//     >
//       <path d="M6 3h12" />
//       <path d="M6 8h12" />
//       <path d="m6 13 8.5 8" />
//       <path d="M6 13h3" />
//       <path d="M9 13c6.667 0 6.667-10 0-10" />
//     </svg>
//   ),

//   Lightning: (props) => (
//     <svg
//       {...props}
//       xmlns="http://www.w3.org/2000/svg"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       // White icon, Blue background, Large Circle
//       className="w-10 h-10 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2.5"
//     >
//       <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
//     </svg>
//   ),

//   Support: (props) => (
//     <svg
//       {...props}
//       xmlns="http://www.w3.org/2000/svg"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       className="w-10 h-10 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2"
//     >
//       <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
//       <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
//     </svg>
//   ),
//   UptimeSpeedIcon: (props) => (
//    <svg
//     {...props}
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//     className="w-10 h-10 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2"
//   >
//     {/* Speedometer/Gauge */}
//     <circle cx="12" cy="12" r="10" />
//     <circle cx="12" cy="12" r="4" />
//     <line x1="4.93" y1="4.93" x2="9.17" y2="9.17" />
//     <line x1="14.83" y1="14.83" x2="19.07" y2="19.07" />
//     <line x1="14.83" y1="9.17" x2="19.07" y2="4.93" />
//     <line x1="4.93" y1="19.07" x2="9.17" y2="14.83" />
//     {/* Checkmark for reliability */}
//     <polyline points="8 12 11 15 16 10" />
//   </svg>
//   ),

//    HonestTrustworthyIcon: (props) => (
//     <svg
//     {...props}
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//     className="w-10 h-10 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2"
//   >
//     {/* Heart */}
//     <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
//     {/* Checkmark over heart */}
//     <path d="m9 12 2 2 4-4" />
//   </svg>

// ),


//   APIIcon: (props) => (
//  <svg
//     {...props}
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//     className="w-10 h-10 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2"
//   >
//     {/* Exact TbApi icon path */}
//     <path d="M4 13h5" />
//     <path d="M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-3" />
//     <path d="M20 8v8" />
//     <path d="M9 16v-5.5a2.5 2.5 0 0 0-5 0v5.5" />
//   </svg>
// ),
// };

// const features = [
//   {
//     icon: 'Rupee',
//     title: 'Genuine & Competitive Pricing',
//     description:
//       'With our low price guarantee, We provide genuine bulk SMS serives in India.',
//   },
//   {
//     icon: 'UptimeSpeedIcon',
//     title: '99.99% Uptime and Speed',
//     description:
//       'Stay connected without delays—99.99% uptime ensures smooth, consistent, and ultra-fast SMS performance.',
//   },
//   {
//     icon: 'Lightning',
//     title: 'Super Fast SMS Delivery',
//     description:
//       'Your SMS reaches customers instantly through our optimized, high-speed delivery channels.',
//   },
//   {
//     icon: 'APIIcon',
//     title: 'Advanced API Integrations',
//     description:
//       'We provide advanced Bulk SMS APIs that seamlessly integrate our services into your software, apps, and websites.',
//   },
//   {
//     icon: 'Support',
//     title: '24*7 Customer Support ',
//     description:
//       'Our dedicated team is on standby 24×7, ensuring you get instant, reliable assistance whenever you need it.',
//   },
//   {
//     icon: 'HonestTrustworthyIcon',
//     title: 'Honest & Trustworthy ',
//     description:
//       'In just 2 to 5 seconds, your OTP SMS reaches customers instantly, powered by the high-speed Eurofox SMS Service infrastructure.',
//   },
// ];

// // Feature card component - styled to match the flat, two-column layout of the source image.
// const FeatureCard = ({ icon, title, description }) => {
//   const IconComponent = icons[icon];
//   return (
//     // Outer container is a column for the entire feature block
//     <div className="flex flex-col space-y-1 ">

//       {/* Icon and Title row (horizontal alignment) */}
//       <div className="flex items-start space-x-2">
//         <div className="flex-shrink-0 mt-1">
//           {/* Using a smaller icon size to match the proportionality in the image, and ensure the title flows next to it */}
//           <IconComponent className="w-6 h-6" />
//         </div>
//         <p className="font-semibold text-[24px] text-gray-800 leading-tight">
//           {title}
//         </p>
//       </div>

//       {/* Description below the Icon/Title line */}
//       <div className="pl-8 ml-4 -mt-2"> {/* Align description text flow underneath the title/icon area */}
//         <p className="text-gray-600 leading-relaxed">
//           {description}
//         </p>
//       </div>
//     </div>
//   );
// };


// export const Eurofox = () => {
//   return (
//     <div className="min-h-screen bg-white flex items-start justify-center p-4 sm:p-16 font-sans">
//       <div className="w-full max-w-6xl">

//         {/* Main Title Section - Styled to match the dark blue/red title */}
//         <header className="text-center mb-12 sm:mb-16 ">
//           <p className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0C4550] leading-tight">
//             Why <span className="text-[#F46653]">EUROFOX</span> is the Best Choice for You?
//           </p>
//         </header>

//         {/* NEW LAYOUT STRUCTURE: Grid to separate the content from the left image space */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-16">

//           {/* Left Column: Image Space (Empty/Placeholder) */}
//           <div className="hidden  lg:block">
//             <img src={smsphoto2} alt="Eurofox platform" className="w-full h-[500px] object-contain" />


//           </div>

//           {/* Right Column: Features Grid (Takes up 2/3 of the space on large screens) */}
//           <main className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-12 lg:gap-y-10">
//             {features.map((feature, index) => (
//               <FeatureCard
//                 key={index}
//                 icon={feature.icon}
//                 title={feature.title}
//                 description={feature.description}
//               />
//             ))}
//           </main>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Eurofox;





import React from 'react';
import { RiCustomerService2Fill } from "react-icons/ri";
// Note: Ensure the path to your image is correct
import smsphoto2 from '../../../src/Components/assets/smsphoto2.webp';

// ... (icons and features definitions remain unchanged)
const icons = {
  Rupee: (props) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-8 h-8 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2"
    >
      <path d="M6 3h12" />
      <path d="M6 8h12" />
      <path d="m6 13 8.5 8" />
      <path d="M6 13h3" />
      <path d="M9 13c6.667 0 6.667-10 0-10" />
    </svg>
  ),

  Lightning: (props) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-10 h-10 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2.5"
    >
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),

  Support: (props) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-10 h-10 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2"
    >
      <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
      <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
    </svg>
  ),
  UptimeSpeedIcon: (props) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-10 h-10 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2"
    >
      {/* Speedometer/Gauge */}
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="4" />
      <line x1="4.93" y1="4.93" x2="9.17" y2="9.17" />
      <line x1="14.83" y1="14.83" x2="19.07" y2="19.07" />
      <line x1="14.83" y1="9.17" x2="19.07" y2="4.93" />
      <line x1="4.93" y1="19.07" x2="9.17" y2="14.83" />
      {/* Checkmark for reliability */}
      <polyline points="8 12 11 15 16 10" />
    </svg>
  ),

  HonestTrustworthyIcon: (props) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-10 h-10 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2"
    >
      {/* Heart */}
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
      {/* Checkmark over heart */}
      <path d="m9 12 2 2 4-4" />
    </svg>
  ),

  APIIcon: (props) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-10 h-10 md:w-12 md:h-12 text-white bg-[#0C4550] rounded-full p-2"
    >
      {/* Exact TbApi icon path */}
      <path d="M4 13h5" />
      <path d="M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-3" />
      <path d="M20 8v8" />
      <path d="M9 16v-5.5a2.5 2.5 0 0 0-5 0v5.5" />
    </svg>
  ),
};

const features = [
  {
    icon: 'Rupee',
    title: 'Genuine & Competitive Pricing',
    description:
      'With our low price guarantee, We provide genuine bulk SMS serives in India.',
  },
  {
    icon: 'UptimeSpeedIcon',
    title: '99.99% Uptime and Speed',
    description:
      'Stay connected without delays—99.99% uptime ensures smooth, consistent, and ultra-fast SMS performance.',
  },
  {
    icon: 'Lightning',
    title: 'Super Fast SMS Delivery',
    description:
      'Your SMS reaches customers instantly through our optimized, high-speed delivery channels.',
  },
  {
    icon: 'APIIcon',
    title: 'Advanced API Integrations',
    description:
      'We provide advanced Bulk SMS APIs that seamlessly integrate our services into your software, apps, and websites.',
  },
  {
    icon: 'Support',
    title: '24*7 Customer Support ',
    description:
      'Our dedicated team is on standby 24×7, ensuring you get instant, reliable assistance whenever you need it.',
  },
  {
    icon: 'HonestTrustworthyIcon',
    title: 'Honest & Trustworthy ',
    description:
      'In just 2 to 5 seconds, your OTP SMS reaches customers instantly, powered by the high-speed Eurofox SMS Service infrastructure.',
  },
];

// Feature card component
const FeatureCard = ({ icon, title, description }) => {
  const IconComponent = icons[icon];
  return (
    <div className="flex flex-col space-y-1 ">
      <div className="flex items-start space-x-2">
        <div className="flex-shrink-0 mt-1">
          <IconComponent className="w-6 h-6" />
        </div>
        <p className="font-semibold text-[24px] text-gray-800 leading-tight">
          {title}
        </p>
      </div>
      <div className="pl-8 ml-4 -mt-2"> 
        <p className="text-gray-600 leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
};

export const Eurofox = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-start justify-center p-4 sm:p-16 font-sans">
      <div className="w-full max-w-7xl">

        {/* UPDATED HEADER SECTION 
            - Added enhanced responsiveness logic (text sizes scale better).
            - Added '3D' text shadow effect to the EUROFOX span.
            - Added a subtle bounce animation on hover to make it feel 'real'.
        */}
        <header className="text-center mb-16 sm:mb-20 px-4">
          <p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-700 leading-tight tracking-tight">
            Why{' '}
            <span 
              className="inline-block text-[#F46653] transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 cursor-default"
              style={{
                // This creates the "3D" / "4D" block effect
                textShadow: '1px 1px 0 #c0392b, 2px 2px 0 #c0392b, 3px 3px 0 #c0392b, 4px 4px 0 #c0392b, 6px 6px 20px rgba(0,0,0,0.25)'
              }}
            >
              EUROFOX
            </span>
            {' '}is the Best Choice for You ?
          </p>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-16">
          <div className="hidden lg:block relative group">
             {/* Added a subtle float animation to the image as well to match the 'real view' vibe */}
            <img 
              src={smsphoto2} 
              alt="Eurofox platform" 
              className="w-full h-[500px] object-contain transition-transform duration-700 hover:scale-105" 
            />
          </div>

          <main className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12 lg:gap-y-10">
            {features.map((feature, index) => (
              <FeatureCard
                key={index}
                icon={feature.icon}
                title={feature.title}
                description={feature.description}
              />
            ))}
          </main>
        </div>
      </div>
    </div>
  );
};

export default Eurofox;